import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import {ValidationConstraint} from '../../domain/validation-constraint';
import * as _ from 'lodash';
import {UtilService} from '../../services/util.service';

@Component({
    selector: 'app-custom-checkbox',
    templateUrl: './custom-checkbox.component.html',
    styleUrls: ['./custom-checkbox.component.scss']
})
export class CustomCheckboxComponent implements OnInit, OnChanges {
    @Input() styleClass: string;
    @Input() result: any;
    @Input() labelPosition: any;
    @Input() value: string;
    @Input() disabled: boolean;
    @Input() label: string;
    @Input() color: any;
    @Input() checked: boolean;
    @Input() errors: object;
    @Input() modelPath: string;
    @Input() validationConstraints: ValidationConstraint[];
    @Input() name: string;
    @Output() toggled = new EventEmitter<boolean>();
    @Output() resultChange = new EventEmitter();

    @ViewChild('control', { static: true }) input: any;
    @ViewChild('frm', { static: true }) form: any;

    public error: string;

    public fieldValidationConstraints: ValidationConstraint[];

    constructor(private cd: ChangeDetectorRef) {
    }

    ngOnInit() {
        this.labelPosition = this.labelPosition || 'before';
        this.checked = this.checked || false;
        this.error = UtilService.getObjByPath(this.errors, this.modelPath);
        this.updataValidationConstraints();
        this.name = this.name || 'control';
    }

    toggle() {
        this.checked = !this.checked;
        this.toggled.emit(this.checked);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.errors !== undefined) {
            this.error = UtilService.getObjByPath(this.errors, this.modelPath);
            if (this.form.form.controls[this.name] && this.error) {
                this.form.form.controls[this.name].markAsTouched(true);
                this.form.form.controls[this.name].setErrors({backend: {someProp: 'some message'}});
            }
        }
        if (!this.error && this.form.form.controls[this.name]) {
            this.form.form.controls[this.name].markAsUntouched(true);
        }

        if (changes.validationConstraints) {
            this.updataValidationConstraints();
        }
        this.cd.markForCheck();
    }

    onModelChanged($event) {
        this.resultChange.emit($event);
        this.cd.markForCheck();
    }

    private updataValidationConstraints() {
        if (this.validationConstraints !== null && this.modelPath) {
            this.fieldValidationConstraints = _.filter(this.validationConstraints, ['field', this.modelPath]);
            this.cd.markForCheck();
        }
    }

}
